import { KyronClient } from 'components/utils/KyronClient';
import { LessonSection, Section } from 'controllers/types';
import { useKyronMutation } from './kyronMutation';
import { useKyronQuery } from './kyronQuery';
import { API_V1 } from './constants';

const client = new KyronClient();

export const useCreateSection = (lessonId: number) =>
  useKyronMutation<Section>(`/simple_lessons/create_section`, {
    method: 'POST',
    invalidates: [`/lessons/${lessonId}/lesson_sections`],
  });

export const useUpdateSection = (sectionId: number, lessonId: number) =>
  useKyronMutation<{ lessonSection: Partial<LessonSection> }, LessonSection>(`/lesson_sections/${sectionId}`, {
    method: 'PUT',
    invalidatesMultiple: [[`/lessons/${lessonId}/lesson_sections`], [`/lesson_sections/${sectionId}`]],
  });

// Use this to create a mutation without knowing which section to update until the mutation is called
export const useUpdateSectionCustom = (lessonId: number) =>
  useKyronMutation<Partial<LessonSection>, LessonSection>(`/lesson_sections`, {
    method: 'PUT',
    invalidates: [`/lessons/${lessonId}/lesson_sections`],
    customMutationFn: async (payload: Partial<LessonSection>) => {
      const form = client.convertJsonToFormData({ lessonSection: payload }, { convertToSnakeCase: true });
      const response: LessonSection = await client.submitJsonDataWithError(
        `${API_V1}/lesson_sections/${payload.id}`, // mutate payload defines which section to mutation
        'PUT',
        form,
      );
      return response;
    },
  });

export const useDeleteSection = (sectionId: number, lessonId: number) =>
  useKyronMutation(`/lesson_sections/${sectionId}`, {
    method: 'DELETE',
    invalidatesMultiple: [[`/lessons/${lessonId}/lesson_sections`], [`/lesson_sections/${sectionId}`]],
  });

export const useSectionQuery = (sectionId?: number) =>
  useKyronQuery<LessonSection>(`/lesson_sections/${sectionId}`, {
    queryKey: ['/lesson_sections', sectionId],
    enabled: !!sectionId,
  });
